import { Controller } from "@hotwired/stimulus"
import { showToast } from "../lib/toast"

// "Roles from company sign-in" (pmfit K6-7 "H"): group → role rows, saved
// with one request and a toast — no page reload.
export default class extends Controller {
  static targets = ["rows", "template", "enabled", "unmatched", "save"]
  static values = { url: String, failed: String }

  addRow() {
    this.rowsTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML)
  }

  removeRow(event) {
    event.currentTarget.closest("[data-access-sso-row]")?.remove()
  }

  async save() {
    const mappings = [...this.rowsTarget.querySelectorAll("[data-access-sso-row]")].map(row => ({
      group_key: row.querySelector('[data-field="group_key"]').value.trim(),
      role: row.querySelector('[data-field="role"]').value,
      view_only: row.querySelector('[data-field="view_only"]').checked
    })).filter(m => m.group_key)
    const unmatched = this.unmatchedTargets.find(r => r.checked)?.value || "keep"
    this.saveTarget.disabled = true
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify({ enabled: this.enabledTarget.checked, unmatched, mappings })
      })
      const data = await response.json().catch(() => ({}))
      if (!response.ok) {
        showToast(data.error || this.failedValue, "error")
        return
      }
      showToast(data.message)
    } catch {
      showToast(this.failedValue, "error")
    } finally {
      this.saveTarget.disabled = false
    }
  }
}
